module.exports = __webpack_public_path__ + "img/行业报告ico.25f4e2e3.png";